/* eslint-disable react/prop-types */
/**
 * OmnitechAppProvider
 * Contain most logic handing with Omnitech Api
 */

import React, {useEffect, useState} from 'react'
import Config from '../../config'
import OmnitechApp from './omnitech-app-context'

export default function OmnitechAppProvider({ children }) {
  const [api, setApi] = useState({})
  useEffect(() => {
    setApi(Config.get('api'))
  }, [Config])

  const state = {
    api
  }
  return (
    <OmnitechApp.Provider value={state}>
      {children}
    </OmnitechApp.Provider>
  )
}
